import React from 'react';
import { Helmet } from 'react-helmet';
import '../css/privacy-policy.css';

const PrivacyPolicy = () => {
  return (
    <div>
      <Helmet>
        <title>Privacy Policy | Skyline Cabs</title>
        <meta name="description" content="Read the Privacy Policy of Skyline Cabs, learn how we collect and protect your data, and understand your rights." />
      </Helmet>

      <section
        className="bg-cover position-relative"
        style={{
          background: 'url(/img/bg-title.jpg) no-repeat',
        }}
        data-overlay="5"
      >
        <div className="container">
          <div className="row align-items-center justify-content-center">
            <div className="col-xl-7 col-lg-9 col-md-12">
              <div className="fpc-capstion text-center my-4">
                <div className="fpc-captions">
                  <h1 className="xl-heading text-light">Privacy Policy</h1>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="privacy-policy">
        <div className="container px-0">
          <div className="row g-0">
            <div className="col-12 col-md-7">
              <h3 className="title">Privacy Policy</h3>

              <p>
                At Skyline Cabs, we prioritize your privacy and are committed to safeguarding your personal information. This Privacy Policy outlines the data we collect, how we use it, and how we protect it.
              </p>

              <div className="section">
                <p className="highlight darkcolor">Information We Collect:</p>
                <p className="highlight darkcolor">1. Personal Information:</p>
                <p>
                  We collect personal details such as name, phone number, email, and payment details to provide seamless cab services.
                </p>

                <p className="highlight darkcolor">2. Usage Data:</p>
                <p>
                  We collect browsing data like IP address, device information, and interaction patterns for website improvement.
                </p>

                <p className="highlight darkcolor">3. Location Data:</p>
                <p>
                  With your consent, we collect location data for accurate ride services and better user experience.
                </p>
              </div>

              <div className="section">
                <p className="highlight darkcolor">How We Use Your Information:</p>
                <p className="highlight darkcolor">1. Service Delivery:</p>
                <p>
                  We use your details for booking confirmations, ride tracking, and payment processing.
                </p>

                <p className="highlight darkcolor">2. User Experience Enhancement:</p>
                <p>
                  Data helps us improve our platform, solve issues, and introduce better features.
                </p>

                <p className="highlight darkcolor">3. Communication:</p>
                <p>
                  We send booking details, ride updates, and service notifications via SMS and email.
                </p>

                <p className="highlight darkcolor">4. Marketing & Promotions:</p>
                <p>
                  With your permission, we send special offers, discounts, and service updates.
                </p>
              </div>

              <div className="section">
                <p className="highlight darkcolor">Information Sharing:</p>
                <p className="highlight darkcolor">1. Trusted Partners:</p>
                <p>
                  We share relevant data with trusted partners for payment processing and customer support.
                </p>

                <p className="highlight darkcolor">2. Legal Compliance:</p>
                <p>
                  We may disclose information when required by law or to protect our rights and safety.
                </p>
              </div>

              <div className="section">
                <p className="highlight darkcolor">Data Security:</p>
                <p>
                  We implement security measures to protect your data but cannot guarantee absolute security against cyber threats.
                </p>

                <p className="highlight darkcolor">Your Rights:</p>
                <p>
                  You can request access, updates, or deletion of your personal data. Opt-out options for marketing communications are available.
                </p>

                <p className="highlight darkcolor">Policy Updates:</p>
                <p>
                  We may update our privacy policy periodically. We encourage you to review it regularly.
                </p>
              </div>
            </div>
          </div>

          <div className="contact-info">
            <h2>Contact Us</h2>
            <p>For any privacy concerns, reach out to us:</p>
            <ul>
              <li><b>Phone:</b> <a href="tel:+917620911746">+91 7620911746</a></li>
              <li><b>Email:</b> <a href="mailto:booking@skylinecabs.com">booking@skylinecabs.com</a></li>
            </ul>
          </div>
        </div>
      </section>
    </div>
  );
};

export default PrivacyPolicy;
